import { z } from "zod";

import { DISCRIMINATOR } from "./common";

type SuccessfulShape<Status extends number, Data extends z.ZodSchema | undefined> = {
  [DISCRIMINATOR]: z.ZodLiteral<Status>;
  body: z.ZodObject<
    Data extends z.ZodSchema
      ? {
          succeeded: z.ZodLiteral<true>;
          data: Data;
        }
      : {
          succeeded: z.ZodLiteral<true>;
        }
  >;
};

function zSuccessful<Status extends number, Data extends z.ZodSchema>(
  status: Status,
  data: Data,
): ReturnType<typeof _zSuccessful<Status, Data>>;
function zSuccessful<Status extends number>(
  status: Status,
): ReturnType<typeof _zSuccessful<Status, undefined>>;
function zSuccessful<Status extends number, Data extends z.ZodSchema | undefined>(
  status: Status,
  data?: Data,
) {
  return _zSuccessful(status, data);
}

function _zSuccessful<Status extends number, Data extends z.ZodSchema | undefined>(
  status: Status,
  data?: Data,
) {
  return z.object({
    [DISCRIMINATOR]: z.literal(status),
    body: z.object({
      succeeded: z.literal(true),
      ...(data && { data }),
    }),
  } as SuccessfulShape<Status, Data>);
}

export { zSuccessful };
